// @flow

import type {ChartType, GraphData, Language, PortfolioNotificationEvent} from '../../types'

import React from 'react'
import {connect} from 'react-redux'
import {mergeAll, map} from 'ramda'
import {
  appActions,
  appSelectors,
  portfoliosActions,
  portfoliosSelectors,
  uiActions,
} from '@/store'

import BarChart from '@/elements/bar-chart'
import DateRangePicker from '@/elements/date-range-picker'
import LineChart from '@/elements/line-chart'
import {getPortfolioName} from '../../store/portfolios/util'
import ChartSelector from './chart-selector'
import {date} from '@/format'

type Props = {
  chartType: string,
  graphData: Array<GraphData>,
  l: Language,
  setChartType: (ChartType) => void,
  langCode: string,
  notificationEvents: Array<PortfolioNotificationEvent>,
  updatefilteredNotificationEvents: () => void,
  activePortfolioId: any,
  portfolios: any,
}

const chartOptions = (l) => [{
  type: 'bar',
  name: l('Bar'),
  id: 'bar_graph',
}, {
  type: 'line',
  name: l('Line'),
  id: 'line_graph',
}]

const formatData = (langCode) => (entry) => {
  return {key: date(entry.key, langCode), value: entry.value}
}

const getFormattedGraphData = (data, langCode) => {
  return map(formatData(langCode), data)
}

const renderChart = (type, title, data, l, notifications, updateFilteredData) => {
  switch (type) {
    case 'bar': return <BarChart title={title} data={data} notifications={notifications}
      updateFilteredData={updateFilteredData}/>
    case 'line': return <LineChart title={title} data={data} notifications={notifications}
      updateFilteredData={updateFilteredData}/>
    default: return null
  }
}

export const RawEventsGraph = (props: Props) => {
  const updateFilteredData = props.updatefilteredNotificationEvents

  return <div>
    <div className="pull-right">
      <ChartSelector
        options={chartOptions(props.l)}
        onClick={props.setChartType}
        selected={props.chartType}
        l={props.l}
      />
      <DateRangePicker/>
    </div>
    {renderChart(props.chartType, `${props.l('Number of events for portfolio')} (${props.l(getPortfolioName(props))})`,
      getFormattedGraphData(props.graphData, props.langCode), props.l,
      props.notificationEvents, updateFilteredData)}
  </div>
}
const mapStateToProps = (state) => ({
  graphData: portfoliosSelectors.getActivePortfolioGraphData(state),
  l: appSelectors.getL(state),
  chartType: state.ui.chartType,
  langCode: state.app.user.preferredLanguageCode,
  notificationEvents: portfoliosSelectors.getActivePortfolioNotificationEvents(state),
  activePortfolioId: appSelectors.getActivePortfolioId(state),
  portfolios: portfoliosSelectors.getPortfolios(state),
})

export default connect(
  mapStateToProps,
  mergeAll([appActions, portfoliosActions, uiActions]),
)(RawEventsGraph)



// WEBPACK FOOTER //
// ./src/views/events-graph/index.js